import { extraListCodes, langsCodes } from "../../../data/main";
import { stdObject } from "../../../data/types/stdObject";
import i18n from "../../../locales/i18n";
import { saveAll } from "../../../store/updateData";
import { arrayToObject } from "../../../utils/arrayToObject";
import { reorderHeaders } from "../../../utils/reorderHeaders";
import { getBranchInfo } from "../../MainFrame/functions/getBranchInfo";
import { updateBackupLang } from "../../MainFrame/functions/updateBackupLang";
import { reorderItem } from "./reorderItem";

export const recordInitData = async ({ initData, dispatch }: stdObject) => {
  try {
    initData.user = getBranchInfo(initData.user);

    const mainSucName = initData.suc.find(
      (e: stdObject) => e.CODSUC === initData.user.CODSUC,
    )?.NOMSUC;
    if (mainSucName) {
      document.title = mainSucName;
    }

    if (initData.words.length > 0) {
      initData.words.forEach((e: stdObject) => {
        const tempCode = `${e.prefix}.${e.code}`;
        if (i18n.exists(tempCode)) {
          updateBackupLang(
            e.lang,
            tempCode,
            i18n.getResource(langsCodes[e.lang], "translation", tempCode),
          );
          i18n.addResource(langsCodes[e.lang], "translation", tempCode, e.text);
        }
      });
    }
    i18n.changeLanguage(langsCodes[initData.user.LANG]);

    if (initData.alm.length < 2) {
      initData.userAccess.A.A6 = 0;
      initData.userAccess.A.A7 = 0;
    }

    initData.usersList = arrayToObject({
      key: `CODUSU`,
      erase: [`CODUSU`],
      data: initData.usersList,
    });

    initData.routes = arrayToObject({
      key: `CODRUT`,
      erase: [`CODRUT`],
      data: initData.rut,
    });

    extraListCodes.forEach((e) => {
      e = e.toLowerCase();
      initData[e] = arrayToObject({
        key: `COD${e.toUpperCase()}`,
        erase: [`COD${e.toUpperCase()}`],
        data: initData[e],
      });
    });

    Object.keys(initData.art).forEach((e) => {
      initData.art[e] = reorderItem(e, initData.art[e], initData);
    });

    initData.headers = reorderHeaders(initData.cab);

    let tempDict: stdObject = {};
    initData.dictList.forEach((e: any) => {
      tempDict[e.CODLIS] = {
        name: e.NOMLIS,
        hideCodes: e.HSHLIS,
        showAll: e.SHWLIS,
        list: initData.dictData
          .filter((v: stdObject) => v.PARLI0 === e.CODLIS)
          .map((v: stdObject) => {
            return { code: v.CODLI0, name: v.NOMLI0 };
          }),
      };
    });
    initData.dictList = tempDict;

    initData.sync = initData.sync.reduce((acc: stdObject, curr: stdObject) => {
      acc[curr.KEYCODE] = curr.TIMELIVE;
      return acc;
    }, {});
    initData.sda = initData.sda.map((e: stdObject) => {
      const extras = initData.sd0.filter(
        (v: stdObject) => v.CODSD0 === e.CODSDA,
      );
      return {
        ...e,
        FORMAT: extras.map((v: stdObject) => v.CODFOR),
        FORSDA: extras.map((v: stdObject) => [v.NOMFOR]),
        GRUSDA: extras.map((v: stdObject) => [v.NOMFOR, v.GRUSD0]),
        ORDSDA: extras.map((v: stdObject) => [v.NOMFOR, v.ORDSD0]),
      };
    });
    // console.log("initData", initData);
    dispatch(saveAll(initData));
    return true;
  } catch (error) {
    // console.log("recordInitDat error: ", error);
  }
  return false;
};
